var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 26.75C7.745 26.75 2.25 21.255 2.25 14.5C2.25 7.745 7.745 2.25 14.5 2.25C21.255 2.25 26.75 7.745 26.75 14.5C26.75 21.255 21.255 26.75 14.5 26.75ZM14.5 4C8.7075 4 4 8.7075 4 14.5C4 20.2925 8.7075 25 14.5 25C20.2925 25 25 20.2925 25 14.5C25 8.7075 20.2925 4 14.5 4Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 26.75C7.745 26.75 2.25 21.255 2.25 14.5C2.25 7.745 7.745 2.25 14.5 2.25C21.255 2.25 26.75 7.745 26.75 14.5C26.75 21.255 21.255 26.75 14.5 26.75ZM14.5 4C8.7075 4 4 8.7075 4 14.5C4 20.2925 8.7075 25 14.5 25C20.2925 25 25 20.2925 25 14.5C25 8.7075 20.2925 4 14.5 4Z",
    fill: "url(#paint0_linear_2241_4869)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 8.375C12.5575 8.375 11 9.9325 11 11.875H12.75C12.75 10.9125 13.5375 10.125 14.5 10.125C15.4625 10.125 16.25 10.9125 16.25 11.875C16.25 13.625 13.625 13.415 13.625 16.25H15.375C15.375 14.29 18 14.0625 18 11.875C18 9.9325 16.4425 8.375 14.5 8.375Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 8.375C12.5575 8.375 11 9.9325 11 11.875H12.75C12.75 10.9125 13.5375 10.125 14.5 10.125C15.4625 10.125 16.25 10.9125 16.25 11.875C16.25 13.625 13.625 13.415 13.625 16.25H15.375C15.375 14.29 18 14.0625 18 11.875C18 9.9325 16.4425 8.375 14.5 8.375Z",
    fill: "url(#paint1_linear_2241_4869)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4991 20.835C15.0983 20.835 15.5841 20.3493 15.5841 19.75C15.5841 19.1508 15.0983 18.665 14.4991 18.665C13.8998 18.665 13.4141 19.1508 13.4141 19.75C13.4141 20.3493 13.8998 20.835 14.4991 20.835Z",
    fill: "#FB5937"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 12.75C12.3582 12.75 12.75 12.3582 12.75 11.875C12.75 11.3918 12.3582 11 11.875 11C11.3918 11 11 11.3918 11 11.875C11 12.3582 11.3918 12.75 11.875 12.75Z",
    fill: "#FFA43D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 17.125C14.9832 17.125 15.375 16.7332 15.375 16.25C15.375 15.7668 14.9832 15.375 14.5 15.375C14.0168 15.375 13.625 15.7668 13.625 16.25C13.625 16.7332 14.0168 17.125 14.5 17.125Z",
    fill: "#FB5937"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2241_4869",
    x1: 15.8021,
    y1: 9.1032,
    x2: 19.5452,
    y2: 19.3841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA43D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB5937"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2241_4869",
    x1: 14.872,
    y1: 10.5778,
    x2: 16.1847,
    y2: 13.7828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA43D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB5937"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/help_icon.0544eef0a1d0b254ae179342e4aecd06.svg";
export { ForwardRef as ReactComponent };